import { useQuery } from '@tanstack/react-query';
import axios from '../../axiosConfig';
import { GET_ORDER_DETAIL } from '../queries/GetOrderDetails';

const fetchOrderDetail = async ({ queryKey }) => {
  const [, { token, orderDetailId, view, setToast}] = queryKey;

  if (!token || !orderDetailId ) throw new Error('token not available');

  const getOrderDetailUrl = `/getOrderDetail?&orderDetailId=${encodeURIComponent(orderDetailId)}&view=${encodeURIComponent(view)}`;
  try {    
    const response = await axios.get(getOrderDetailUrl, {
        headers: {
        Authorization: token,
        },
    }); 

    return response.data;

  } catch (error) {
    setToast({ showToast: true, message: error.response?.data, type: 'error' });      
  }
};

export const useGetOrderDetailData = (params ) => {
  return useQuery({
    queryKey: [GET_ORDER_DETAIL, params ],
    queryFn: fetchOrderDetail,
    enabled: !!params.token && !!params.orderDetailId,
    retry: false,
  });
};